import { render } from "./BannerIndicator.vue?vue&type=template&id=039f782e&ts=true"
import script from "./BannerIndicator.vue?vue&type=script&lang=ts"
export * from "./BannerIndicator.vue?vue&type=script&lang=ts"

import "./BannerIndicator.vue?vue&type=style&index=0&id=039f782e&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__